import React from "react";
import Footer from "../../components/Footer";
import GalleryNavbar from "../../components/GalleryNavbar";
import GalleryContent from "../../components/GalleryContent";

import Head from "../../Page";

const Gallery = () => {
  return (
    <Head title="Galerie">
      <GalleryNavbar />
      <GalleryContent />
      <Footer />
    </Head>
  );
};
export default Gallery;
